import React from "react";
import { Collapse, Icon } from "antd";

const { Panel } = Collapse;

const openWidget = (e) => {
  e.preventDefault()
  window.zE('webWidget', 'toggle')
}

const QA_LIST = [
  {
    title: "How long will my order take to be delivered?",
    content: <p>
      Please refer to the store or merchant from where you placed your order to get more information on delivery lead times.
      If your delivery is taking longer than expected, please reach out to us by filling in the required details in the <a href={() => false} onClick={openWidget}>web widget</a> found in the lower right portion of this page.
    </p>
  },
  {
    title:
      "My order seems to be stuck at a certain stage of delivery. Why is it stuck?",
    content:<p>
      Janio works with several network delivery partners to ensure we get your packages to you at the soonest possible time.
      If the status of your package has been stuck at a certain stage longer than expected, please reach out to us by filling in the <a href={() => false} onClick={openWidget}>web widget</a> found in the lower right portion of this page.
      Our customer service agents will be more than happy to help address your concerns.'
    </p>
  },
  {
    title: "My delivery is late. Is this normal?",
    content: <p>
      Late deliveries are never fun. While we do our best to deliver your parcels as fast as we can, delays may still happen from time to time.
      In such situations, please rest assured that we will follow up closely on the delivery status of your parcel and ensure that it reaches you as soon as possible.
      If you would like to speak to our customer service agents, you may do so by filling in the <a href={() => false} onClick={openWidget}>web widget</a> found in the lower right portion of this page.
    </p>
  },
  {
    title: "I wasn’t around when my delivery arrived! What do I do?",
    content: <p>
      At Janio, we do our best to get your packages to you at the soonest possible time.
      If you were not around to receive the package when the first delivery was attempted, we will re-attempt two (2) more times.
      If you need to reschedule a delivery, please reach out to us by filling in the <a href={() => false} onClick={openWidget}>web widget</a> found in the lower right portion of this page and we will do our best to accommodate your request.
    </p>
  },
  {
    title:
      "The tracker status shows “Success”, but I did not receive my parcel.",
    content: <p>
      Janio works with several network delivery partners to ensure we get your packages to you at the soonest possible time.
      If the status on our tracker page has been updated incorrectly, please reach out to us by filling in the <a href={() => false} onClick={openWidget}>web widget</a> found in the lower right portion of this page.
      Our friendly customer service agents will be more than happy to help resolve your concerns.<br/><br/>
      If the tracker status is showing “Success” but you haven’t received your parcel, it could be due to one of several reasons:<br/><br/>
        1. The shipping address from your order is different. Kindly check if it matches the address you’re expecting your order to be delivered to.<br/>
        2. Someone else received the parcel on your behalf. This information is usually available on the tracker page when you click on Show Details.<br/><br/> The status on our tracker page has been updated incorrectly.
          Please reach out to us by filling in the <a href={() => false} onClick={openWidget}>web widget</a> found in the lower right portion of this page.
      Our customer service team will be more than happy to help address your concerns.
    </p>
  }
];

export default class FAQ extends React.Component {
  render() {
    return (
      <main style={{ textAlign: "left", paddingBottom: 80, paddingTop: 20 }}>
        <div className="custom-breadcrumb">
          <div className="breadcrumb-wrap">
            <div style={{ flex: 0.7 }} className="back">
              <a href={() => false} onClick={() => this.props.history.goBack()}>
                <Icon type="left" /> Back
              </a>
            </div>
            <div style={{ flex: 1 }} className="page-name">
              FAQ
            </div>
          </div>
        </div>
        <h1 className="topic">How Can We Help You?</h1>

        <Collapse
          bordered={false}
          defaultActiveKey={["0"]}
          expandIcon={({ isActive }) =>
            isActive ? <Icon type="minus" /> : <Icon type="plus" />
          }
          expandIconPosition={"right"}
          style={{ background: "transparent" }}
        >
          {QA_LIST.map((qa, index) => {
            return (
              <Panel header={qa.title} key={index}>
                <p className="content faq-container">
                  {qa.content}
                </p>
              </Panel>
            );
          })}
        </Collapse>
      </main>
    );
  }
}
